import RenderComponents from "./RenderByType/RenderComponents";
export default RenderComponents;